export default __webpack_public_path__ + "static/media/polig.06ea6851.svg";